"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFlowView = exports.STAGES = void 0;
const React = require("react");
const react_1 = require("react");
const RetailCustomerWrapper_1 = require("../../checkout/RetailCustomerWrapper");
const PayDocRetailLocationHandler_1 = require("../../handlers/PayDocRetailLocationHandler");
const PendingContentBlock_1 = require("../../../../../components/base/structure/PendingContentBlock");
const useClient_1 = require("../../../../../hooks/useClient");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const StripePromiseProvider_1 = require("../../../../../components/base/payments/StripeCreditCardForm/StripePromiseProvider");
const StripePaymentRequestProvider_1 = require("../../../../../components/base/payments/StripeCreditCardForm/StripePaymentOptions/StripePaymentRequestProvider");
const StripePaymentOptionsProvider_1 = require("../../../../../components/base/payments/StripeCreditCardForm/StripePaymentOptions/StripePaymentOptionsProvider");
const StripeCartOverview_1 = require("../../../../../components/base/payments/StripeCreditCardForm/Cart/StripeCartOverview");
const ProgressStepper_1 = require("../../../../../components/base/atoms/ProgressStepper");
const StripePaymentNativeOptions_1 = require("../../../../../components/base/payments/StripeCreditCardForm/StripePaymentOptions/StripePaymentNativeOptions");
const SavedPaymentProvider_1 = require("../../../../../components/base/payments/StripeCreditCardForm/Hooks/SavedPaymentProvider");
const ConfirmationDialog_1 = require("../../../../../components/base/payments/StripeCreditCardForm/BasicComponents/ConfirmationDialog");
const css = (0, cssComposer_1.default)(styles, "CheckoutFlowView");
exports.STAGES = ["Account", "Payment", "Processing"];
const CheckoutFlowView = ({ processSalesOrderError, validateOrder, processOrder, onSignUp, onStageChange }) => {
    let stageLabels = {
        Account: "LOGIN",
        Payment: "PAYMENT",
        Processing: "ORDER"
    };
    const client = (0, useClient_1.useClient)();
    const [stage, setStage] = (0, react_1.useState)("Account");
    // const  = useStripeCheckout();
    const stages = (0, react_1.useMemo)(() => exports.STAGES, []);
    const stagesLength = (0, react_1.useMemo)(() => stages.length, [stages]);
    const processingOrder = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => typeof onStageChange === "function" && onStageChange(stage), [
        stage
    ]);
    (0, react_1.useEffect)(() => {
        if (processingOrder.current)
            return;
        if (stage !== "Processing")
            return;
    }, [stage, processOrder]);
    (0, react_1.useEffect)(() => {
        if (stage !== "Processing")
            return;
        if (processSalesOrderError) {
            setStage("Payment");
        }
    }, [processSalesOrderError]);
    (0, react_1.useEffect)(() => {
        if (stage !== "Processing")
            processingOrder.current = false;
    }, [stage]);
    const getContent = React.useCallback(() => {
        switch (stage) {
            case "Account":
                return (React.createElement(RetailCustomerWrapper_1.RetailCustomerWrapper, { onCompletion: () => {
                        setStage("Payment");
                    }, onSignUp: onSignUp }));
            case "Payment":
                return (React.createElement(StripePromiseProvider_1.StripePromiseProvider, { key: "MainStripeProvider" },
                    React.createElement(StripePaymentNativeOptions_1.StripeNativeOptionsProvider, null,
                        React.createElement(StripePaymentRequestProvider_1.StripePaymentRequestProvider, { validateOrder: validateOrder, onSuccessfulPayment: paymentId => {
                                setStage("Processing");
                                processingOrder.current = true;
                                processOrder(paymentId, true);
                            } },
                            React.createElement(SavedPaymentProvider_1.SavedPaymentProvider, null,
                                React.createElement(ConfirmationDialog_1.ConfirmationProvider, null,
                                    React.createElement(StripePaymentOptionsProvider_1.StripePaymentOptionsProvider, null,
                                        React.createElement(StripeCartOverview_1.default, null))))))));
            case "Processing":
                return (React.createElement(PendingContentBlock_1.PendingContentBlock, { size: "payDock", check: false, message: "Please wait while we place your order..." }));
        }
    }, [client.auth, stage]);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("progress") },
            React.createElement(ProgressStepper_1.default, { Steps: Object.values(stageLabels), CurrentStep: stageLabels[stage] })),
        React.createElement(PayDocRetailLocationHandler_1.PayDocRetailLocationHandler, null, getContent())));
};
exports.CheckoutFlowView = CheckoutFlowView;
//# sourceMappingURL=index.js.map